<template>
<div class="scoreEdit">
  <div class="edit">
    <img style="width: 15px;" :src="require('./kh.png')"/>
    <div class="yf">
      <img :src="require('./gy.png')"/>
      <img :src="require('./dy.png')"/>
    </div>
    <div class="yd">
      <select v-model="gyd">
        <option value=""></option>
        <option value="#">#</option>
        <option value="##">##</option>
        <option value="###">###</option>
        <option value="###">####</option>
        <option value="###">#####</option>
        <option value="###">######</option>
        <option value="###">#######</option>
        <option value="b">b</option>
        <option value="bb">bb</option>
        <option value="bbb">bbb</option>
        <option value="bbbb">bbbb</option>
        <option value="bbbbb">bbbbb</option>
        <option value="bbbbbb">bbbbbb</option>
        <option value="bbbbbbb">bbbbbbb</option>
      </select>
      <select v-model="dyd">
        <option value=""></option>
        <option value="#">#</option>
        <option value="##">##</option>
        <option value="###">###</option>
        <option value="###">####</option>
        <option value="###">#####</option>
        <option value="###">######</option>
        <option value="###">#######</option>
        <option value="b">b</option>
        <option value="bb">bb</option>
        <option value="bbb">bbb</option>
        <option value="bbbb">bbbb</option>
        <option value="bbbbb">bbbbb</option>
        <option value="bbbbbb">bbbbbb</option>
        <option value="bbbbbbb">bbbbbbb</option>
      </select>
    </div>
    <div class="wireContent">
      <div class="gy">
        <wire @mouseout="wireUp(true,7,10)" @mouseup="wireUp(true,7,10)" @mousedown="wireDown(true,7,10)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,7,8)" @mouseup="wireUp(true,7,8)" @mousedown="wireDown(true,7,8)" color="#808080"></wire>
        <wire @mouseout="wireUp(true,7,6)" @mouseup="wireUp(true,7,6)" @mousedown="wireDown(true,7,6)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,7,5)" @mouseup="wireUp(true,7,5)" @mousedown="wireDown(true,7,5)" color="#808080"></wire>
        <wire @mouseout="wireUp(true,7,3)" @mouseup="wireUp(true,7,3)" @mousedown="wireDown(true,7,3)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,7,1)" @mouseup="wireUp(true,7,1)" @mousedown="wireDown(true,7,1)" color="#808080"></wire>
        <wire @mouseout="wireUp(true,6,12)" @mouseup="wireUp(true,6,12)" @mousedown="wireDown(true,6,12)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,6,10)" @mouseup="wireUp(true,6,10)" @mousedown="wireDown(true,6,10)" color="#808080"></wire>
        <wire @mouseout="wireUp(true,6,8)" @mouseup="wireUp(true,6,8)" @mousedown="wireDown(true,6,8)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,6,6)" @mouseup="wireUp(true,6,6)" @mousedown="wireDown(true,6,6)"></wire>
        <wire @mouseout="wireUp(true,6,5)" @mouseup="wireUp(true,6,5)" @mousedown="wireDown(true,6,5)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,6,3)" @mouseup="wireUp(true,6,3)" @mousedown="wireDown(true,6,3)"></wire>
        <wire @mouseout="wireUp(true,6,1)" @mouseup="wireUp(true,6,1)" @mousedown="wireDown(true,6,1)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,5,12)" @mouseup="wireUp(true,5,12)" @mousedown="wireDown(true,5,12)"></wire>
        <wire @mouseout="wireUp(true,5,10)" @mouseup="wireUp(true,5,10)" @mousedown="wireDown(true,5,10)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,5,8)" @mouseup="wireUp(true,5,8)" @mousedown="wireDown(true,5,8)"></wire>
        <wire @mouseout="wireUp(true,5,6)" @mouseup="wireUp(true,5,6)" @mousedown="wireDown(true,5,6)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,5,5)" @mouseup="wireUp(true,5,5)" @mousedown="wireDown(true,5,5)"></wire>
        <wire @mouseout="wireUp(true,5,3)" @mouseup="wireUp(true,5,3)" @mousedown="wireDown(true,5,3)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,5,1)" @mouseup="wireUp(true,5,1)" @mousedown="wireDown(true,5,1)" color="#808080"></wire>
        <wire @mouseout="wireUp(true,4,12)" @mouseup="wireUp(true,4,12)" @mousedown="wireDown(true,4,12)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(true,4,10)" @mouseup="wireUp(true,4,10)" @mousedown="wireDown(true,4,10)" color="#808080"></wire>
        <wire @mouseout="wireUp(true,4,8)" @mouseup="wireUp(true,4,8)" @mousedown="wireDown(true,4,8)" width="50%" color="#D9D9D9"></wire>
      </div>
      <div class="dy">
        <wire @mouseout="wireUp(false,5,6)" @mouseup="wireUp(false,5,6)" @mousedown="wireDown(false,5,6)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,5,5)" @mouseup="wireUp(false,5,5)" @mousedown="wireDown(false,5,5)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,5,3)" @mouseup="wireUp(false,5,3)" @mousedown="wireDown(false,5,3)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,5,1)" @mouseup="wireUp(false,5,1)" @mousedown="wireDown(false,5,1)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,4,12)" @mouseup="wireUp(false,4,12)" @mousedown="wireDown(false,4,12)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,4,10)" @mouseup="wireUp(false,4,10)" @mousedown="wireDown(false,4,10)"></wire>
        <wire @mouseout="wireUp(false,4,8)" @mouseup="wireUp(false,4,8)" @mousedown="wireDown(false,4,8)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,4,6)" @mouseup="wireUp(false,4,6)" @mousedown="wireDown(false,4,6)"></wire>
        <wire @mouseout="wireUp(false,4,5)" @mouseup="wireUp(false,4,5)" @mousedown="wireDown(false,4,5)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,4,3)" @mouseup="wireUp(false,4,3)" @mousedown="wireDown(false,4,3)"></wire>
        <wire @mouseout="wireUp(false,4,1)" @mouseup="wireUp(false,4,1)" @mousedown="wireDown(false,4,1)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,3,12)" @mouseup="wireUp(false,3,12)" @mousedown="wireDown(false,3,12)"></wire>
        <wire @mouseout="wireUp(false,3,10)" @mouseup="wireUp(false,3,10)" @mousedown="wireDown(false,3,10)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,3,8)" @mouseup="wireUp(false,3,8)" @mousedown="wireDown(false,3,8)"></wire>
        <wire @mouseout="wireUp(false,3,6)" @mouseup="wireUp(false,3,6)" @mousedown="wireDown(false,3,6)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,3,5)" @mouseup="wireUp(false,3,5)" @mousedown="wireDown(false,3,5)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,3,3)" @mouseup="wireUp(false,3,3)" @mousedown="wireDown(false,3,3)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,3,1)" @mouseup="wireUp(false,3,1)" @mousedown="wireDown(false,3,1)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,2,12)" @mouseup="wireUp(false,2,12)" @mousedown="wireDown(false,2,12)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,2,10)" @mouseup="wireUp(false,2,10)" @mousedown="wireDown(false,2,10)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,2,8)" @mouseup="wireUp(false,2,8)" @mousedown="wireDown(false,2,8)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,2,6)" @mouseup="wireUp(false,2,6)" @mousedown="wireDown(false,2,6)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,2,5)" @mouseup="wireUp(false,2,5)" @mousedown="wireDown(false,2,5)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,2,3)" @mouseup="wireUp(false,2,3)" @mousedown="wireDown(false,2,3)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,2,1)" @mouseup="wireUp(false,2,1)" @mousedown="wireDown(false,2,1)" width="50%" color="#D9D9D9"></wire>
        <wire @mouseout="wireUp(false,1,3)" @mouseup="wireUp(false,1,3)" @mousedown="wireDown(false,1,3)" color="#808080"></wire>
        <wire @mouseout="wireUp(false,1,1)" @mouseup="wireUp(false,1,1)" @mousedown="wireDown(false,1,1)" width="50%" color="#D9D9D9"></wire>
      </div>
    </div>
  </div>
  <div class="end"></div>
</div>
</template>

<script>
import Wire from './Wire.vue'
export default {
  components: { Wire },
  name:"ScoreEdit",
  data(){
    return{
      gyd:"",
      dyd:""
    }
  },
  methods:{
    downYd:function(yd,areaPos,pos){
      // 降号顺序为 ‌B、E、A、D、G、C、F‌
      if(areaPos==1){
        switch(pos){
          case 3:
            if(yd.length>0){
              pos--;
            }
            break;
        }
      }else{
        switch(pos){
          case 1:
            if(yd.length>5){
              areaPos--;
              if(areaPos==1){
                pos=3;
              }else{
                pos=12;
              }
            }
            break;
          case 3:
            if(yd.length>3){
              pos--;
            }
            break;
          case 5:
            if(yd.length>1){
              pos--;
            }
            break;
          case 6:
            if(yd.length>6){
              pos--;
            }
            break;
          case 8:
            if(yd.length>4){
              pos--;
            }
            break;
          case 10:
            if(yd.length>2){
              pos--;
            }
            break;
          case 12:
            if(yd.length>0){
              pos--;
            }
            break;
        }
      }
      return {areaPos:areaPos,pos:pos};
    },
    upYd:function(yd,areaPos,pos){
      // 升号顺序为F-C-G-D-A-E-B‌
      if(areaPos==1){
        switch(pos){
          case 1:
            if(yd.length>4){
              pos++;
            }
            break;
          case 3:
            if(yd.length>6){
              areaPos++;
              pos=1;
            }
        }
      }else{
        switch(pos){
          case 1:
            if(yd.length>1){
              pos++;
            }
            break;
          case 3:
            if(yd.length>3){
              pos++;
            }
            break;
          case 5:
            if(yd.length>5){
              pos++;
            }
            break;
          case 6:
            if(yd.length>0){
              pos++;
            }
            break;
          case 8:
            if(yd.length>2){
              pos++;
            }
            break;
          case 10:
            if(yd.length>4){
              pos++;
            }
            break;
          case 12:
            if(yd.length>6){
              pos=1;
              areaPos++;
            }
            break;
        }
      }
      return {areaPos:areaPos,pos:pos};
    },
    getPos:function(isGy,areaPos,pos){
      let res=null;
      if(isGy){
        if(this.gyd.includes("#")){
          res=this.upYd(this.gyd,areaPos,pos);
        }else{
          res=this.downYd(this.gyd,areaPos,pos);
        }
      }else{
        if(this.dyd.includes("#")){
          res=this.upYd(this.dyd,areaPos,pos);
        }else{
          res=this.downYd(this.dyd,areaPos,pos);
        }
      }
      return res;
    },
    wireDown:function(isGy,areaPos,pos){
      let res=this.getPos(isGy,areaPos,pos);
      this.$emit("wireDown",res.areaPos,res.pos);
    },
    wireUp:function(isGy,areaPos,pos){
      let res=this.getPos(isGy,areaPos,pos);
      this.$emit("wireUp",res.areaPos,res.pos);
    }
  }
}
</script>

<style lang="less" scoped>
.scoreEdit{
  width: 100%;
  // height: 100%;
  height: 100vh;
  overflow: auto;
  padding: 15px;
  .edit{
    width: 100%;
    height: 360px;
    display: flex;
    .yf{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      img{
        height: 40%;
        width: 50px;
      }
    }
    .yd{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      height: 100%;
    }
    .wireContent{
      width: 80%;
      height: 100%;
      border-left: solid black;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .end{
    // width: 100%;
    height: 300px;
  }
}
</style>